import api from './api';

export function getConnectedStations(data) {
  return api.post('/tars/machine-sync/get-connected-stations', JSON.stringify(data))
}

export function getFactoryStationLocations(data) {
  return api.post('/tars/user/get-factory-station-locations', JSON.stringify(data))
}

export function getLocationProductivity(data) {
  return api.post('/tars/parts/locationproductivity', JSON.stringify(data))
}

export function fetchItemList(data) {
  return api.post('/tars/items/fetch-item-list', JSON.stringify(data))
}

export function fetchBoardData(data) {
  return api.post('/tars/stockpile/get-stockpile-detail', JSON.stringify(data))
}

export function fetchSwatchData(data) {
  return api.post('/tars/items/fetch-board-shade-swatch', JSON.stringify(data))
}

export function fetchMaterialImage(data) {
  return api.post('/tars/items/fetch-doc-image', JSON.stringify(data))
}

export function getBoardScanDetail(data) {
  return api.post('/tars/stockpile/stockpile-board-scan-detail', JSON.stringify(data))
}

export function updateStation(data) {
  return api.post('/tars/parts/updatestation', JSON.stringify(data))
}

export function linkInventoryToBook(data) {
  return api.post('/tars/stockpile/link-inventory-to-book', JSON.stringify(data))
}

export function getInventoryDetail(data) {
  return api.post('/tars/inventory/fetchinventorydetail', JSON.stringify(data))
}

export function fetchProjectData(data) {
  return api.post('/tars/stockpile/get-stockpile-projects', JSON.stringify(data))
}